import {inject, observer} from 'mobx-react';
import * as React from 'react';
import {Redirect, RouteComponentProps, withRouter} from 'react-router-dom';
import {ChatChannelKind} from '../../models/chatChannelModel';
import {ChatModelType} from '../../models/chatModel';

type AnaChatRouteParams = {
  channelKind: string;
  channelId: string;
};

interface WithInjectedProps extends RouteComponentProps<AnaChatRouteParams> {
  chat: ChatModelType;
}

@inject('chat')
@observer
class AnaChat extends React.Component<RouteComponentProps, {}> {
  public componentDidMount() {
    const {loadChannels, setCurrentChannelType} = this._withInjectedProps.chat;

    setCurrentChannelType(this._channelKind);
    loadChannels(this._channelKind);
  }

  public render() {
    const {
      chat: {sortedChannels},
      match: {params}
    } = this._withInjectedProps;

    if (sortedChannels && sortedChannels.length > 0 && !params.channelId) {
      return (
        <Redirect
          to={`/ana-messages/${this._channelKind}/${sortedChannels[0].id}`}
        />
      );
    }

    return null;
  }

  private get _withInjectedProps() {
    return this.props as WithInjectedProps;
  }

  private get _channelKind() {
    return ChatChannelKind.SUPPORT;
  }
}

export default withRouter(AnaChat);



// WEBPACK FOOTER //
// ./src/pages/AnaChat/AnaChat.tsx